import React from "react";
import { connect } from "react-redux";
import { browserHistory } from "react-router";
import PropTypes from 'prop-types';

import Filters from "./Filters";
import TeamList from "../TeamList";
import * as workableActions from "../../modules/workable";
import Static from "../../lib/Static";
import style from "./CurrentOpenings.css";
import Posting from "../Posting";
import { Corona } from "../Corona";


class CurrentOpenings extends React.Component {
  constructor () {
    super();

    // temporary solution for API Gateway not allowing multiple domains in
    // Access-Control-Allow-Origin header
    if (window.location.href.includes("www")) {
      window.location.assign(window.location.href.replace("www.", ""));
    }

    this.state = {
      selectedLanguage: "en",
      displayCorona: false
    };
  }

  async componentDidMount () {
    await this.props.getJobs();
  }

  handleFilterChange (filter, value) {
    let location = Object.assign({}, browserHistory.getCurrentLocation());
    let query = {};

    if (value !== -1) {
      query[filter] = value;
    } else {
      delete location.query[filter];
    }
    Object.assign(location.query, query);
    browserHistory.push(location);
  }

  getFilteredJobs (selectedOfficeId, filterByRemote, jobs) {
    let filteredJobs = jobs;
    if (selectedOfficeId !== -1) {
      const ids = Static.offices[selectedOfficeId].workableCountryCodes;

      // filter the jobs according to location, but exclude talent pool (job id 15702c) from this filtering so that it appears
      // in all markets
      filteredJobs = filteredJobs.filter((job) => ids.includes(job.location.country_code) || job.id === "15702c" );
    }
    if (filterByRemote) {
      filteredJobs = filteredJobs.filter((job) => job.location.telecommuting);
    }
    return filteredJobs;
  }

  render () {
    const { workableJobs, selectedOfficeId, selectedDeptId, jobId, filterByRemote } = this.props;
    const filteredJobs = this.getFilteredJobs(selectedOfficeId, filterByRemote, workableJobs);

    if (jobId !== null && workableJobs.length) {
      const job = workableJobs.find((workableJob) => workableJob.id === jobId);

      return (
        <Posting
          job={job}
        />
      );
    }

    return (
      <div className={style.currentOpenings}>
        <div className={style.hero}>
          <div className={style.content}>
            <div className={style.heroRow}>
              <div className={style.filters}>
                <h2 className={style.title}>Current Openings</h2>
                <Filters
                  selectedOfficeId={selectedOfficeId}
                  selectedDeptId={selectedDeptId}
                  filterForRemote={filterByRemote}
                  onFilterChange={this.handleFilterChange}
                />
              </div>
            </div>
          </div>
        </div>
        {
          this.state.displayCorona && <div className={style.corona}>
            <Corona
              locale={this.state.selectedLanguage}
              onClick={(locale) => this.setState({ selectedLanguage: locale })}
              onClose={() => this.setState({ displayCorona: false })}
            />
          </div>
        }
        <TeamList
          teamId={selectedDeptId}
          jobs={filteredJobs}
        />
      </div>
    );
  }
}

CurrentOpenings.propTypes = {
  getJobs: PropTypes.func.isRequired,
  workableJobs: PropTypes.array.isRequired,
  selectedDeptId: PropTypes.number,
  selectedOfficeId: PropTypes.number,
  filterByRemote: PropTypes.bool,
  jobId: PropTypes.string
};

const mapStateToProps = (state, props) => {
  const deptId = props.location.query.department;
  const officeId = props.location.query.office;
  const jobId = props.location.query.id;
  const filterByRemote = props.location.query.remote;

  return {
    selectedDeptId: deptId ? parseInt(deptId, 10) : -1,
    selectedOfficeId: officeId ? parseInt(officeId, 10) : -1,
    filterByRemote: filterByRemote === "true",
    jobId: jobId || null,
    workableJobs: state.workable.jobs,
    displayCoronaUpdate: state.displayCoronaUpdate,
  };
};

const actions = {
  getJobs: workableActions.getJobs
};

const CurrentOpeningsContainer = connect(mapStateToProps, actions)(CurrentOpenings);

export default CurrentOpeningsContainer;



// WEBPACK FOOTER //
// ./component/CurrentOpenings/index.js